import { palette } from '@/theme/palette';
import { createTypographyVariants } from 'hx-util';
export var typography = {
    styleOverrides: {
        root: {
            marginInline: 'auto',
            textAlign: 'center',
            fontFamily: 'Inter, sans-serif',
            color: palette.text.primary,
        },
    },
    variants: createTypographyVariants({
        h1: {
            fontSize: '2.125rem',
            textTransform: 'uppercase',
            fontWeight: '800',
        },
        h2: {
            fontSize: '1.625rem',
            fontWeight: '800',
        },
        h5: {
            fontSize: '1rem',
            fontWeight: '900',
        },
        h6: {
            fontSize: '0.6875rem',
            fontWeight: '900',
        },
        subhead: {
            fontSize: '0.875rem',
        },
        body1: {
            fontSize: '0.875rem',
            fontWeight: 'inherit',
        },
        body2: {
            textAlign: 'left',
            fontSize: '0.675rem',
        },
        info: {
            fontSize: '0.75rem',
        },
        small: {
            fontSize: '0.625rem',
        },
        disclaimer: {
            fontSize: '0.4375rem',
            textAlign: 'left',
            fontStyle: 'italic',
            fontWeight: '100',
            lineHeight: '0.625rem',
        },
        'disclaimer-link': {
            fontSize: '0.4375rem',
            textAlign: 'left',
            fontStyle: 'italic',
            color: palette.text.primary + ' !important',
            textDecorationColor: palette.text.primary + ' !important',
            fontWeight: '100',
        },
        list: {
            fontSize: '0.4375rem',
        },
        'subhead-bold': {
            fontSize: '0.875rem',
            fontWeight: '900',
        },
        link: {
            fontSize: '0.75rem',
            color: palette.text.primary,
            opacity: '0.61',
            textDecorationColor: palette.text.primary,
        },
    }),
};
